<template>
  <Form
    ref="queryForm"
    class="form-flex label-hide"
    label-position="left"
    :label-width="80"
    :model="queryModel"
    :rules="rules"
    @submit.native.prevent
  >
  <h2 v-if="type === 'car'">汽車險</h2>
  <h2 v-else>機車險</h2>
    <GroupRadio
      v-if="type === 'car'"
      v-model="queryModel.gender"
      type="button"
      label="性別"
      :radios="radios"
    />
    <BaseVueSelect
      v-else
      v-model="queryModel.typeOfMotor"
      prop="typeOfMotor"
      label="車種"
      :options="options.typeOfMotor"
    />
    <DateVueSelect
      v-model="queryModel.dateOfBirth"
      prop="dateOfBirth"
      label="車主生日"
      age
      :placeholder="placeholderOwnBirth"
    />
    <CarNoGroup
      v-model="queryModel.carNo"
      prop="Carno"
    />
    <BaseVueSelect
      v-if="type === 'car'"
      v-model="queryModel.expectPremium"
      label="期望保費"
      prop="expectPremium"
      :options="options.expectPremium[type]"
      :placeholder="placeholderExpectPremium"
    /> 
    <GroupRadio
      v-if="type === 'car'"
      v-model="queryModel.cdi"
      type="button"      
      label="投保丙式"
      :radios="cdi"
    />     
    <div class="form-footer clearfix mb-s">
      <Button
        class="pull-right btn-primary btn-m btn-shadow"
        :loading="loading"
        @click="handleSubmit"
      >
        <span v-if="!loading">快速試算保費</span>
        <span v-else>請稍候</span>
      </Button>
    </div>
    <div class="notice">
      <p>* 保費試算以三年無肇事為基礎。</p>
      <p>* 快速試算之保費僅供參考，仍應以實際投保資料計算為準。</p>
    </div>
  </Form>
</template>

<script>
  // components
  import { Form, Button } from 'iview';
  import GroupRadio from '@/components/forms/elements/GroupRadio';
  import BaseVueSelect from '@/components/forms/elements/BaseVueSelect';
  import DateVueSelect from '@/components/forms/elements/DateVueSelect';
  import CarNoGroup from '@/components/forms/elements/CarNoGroup';
  import { gender,CarBody } from '@/staticData/radios';
  // asyncValidator
  import { carRules, motorRules, options } from '@/utils/asyncValidator/queryForms';

  export default {
    inheritAttrs: false,
    components: {
      Form,
      GroupRadio,
      BaseVueSelect,
      CarNoGroup,
      Button,
      DateVueSelect
    },
    props: {
      rules: {
        type: Object,
        default() {
          return this.type === 'car' ? carRules : motorRules;
        } 
      },
      model: {
        type: Object,
        default: null
      },
      type: {
        type: String,
        default: null
      },
      Carno: {
        type: String,
        default() {
          //console.log(this.Carno);
          return this.Carno ==null?null:this.Carno;
        }
      },
      loading: {
        type: Boolean,
        default: false
      },
      handleQuery: {
        type: Function,
        default: () => {}
      }
    },
    data() {
      const queryModel = this.$cloneDeep(this.model);
        if (this.Carno!=null)
        {
          //console.log(this.Carno);
           var block= this.Carno.split("-");
           //console.log("block[0]:"+block[0]+"    block[1]:"+block[1]);
           // console.log(block.length);
         //if( this.type === 'car'){
        if (block.length==2){
            queryModel.carNo.block1=block[0];
            queryModel.carNo.block2=block[1];
            //queryModel.carNo.block1="000";
            //queryModel.carNo.block2="111"
         }else{
            queryModel.carNo.block1=block[0];
            queryModel.carNo.block2=block[1];
           // queryModel.carNo.block1=this.Carno.substring(0,3);
           // queryModel.carNo.block2=this.Carno.substring(3,7);
         //queryModel.carNo.block1="123";
            //queryModel.carNo.block2="456";
         }
        }
      //console.log(queryModel);
      return {
        radios: gender,
        options,
        cdi: CarBody,
        queryModel,
        placeholderOwnBirth: {
          year: '生日年份',
          month: '選擇月份',
          day: '選擇日期' 
        },
        placeholderExpectPremium: '期望保費'
      };
    },
    computed: {
      formatCarNo() {
        const { block1, block2 } = this.queryModel.carNo;
        return block1 && block2 ? `${block1}-${block2}` : null;
      },
      premiumLabel() {
        const { queryModel, options, type } = this;
        if (!queryModel.expectPremium) return null;
        const { expectPremium } = options;
        const { label } = expectPremium[type]
          .find(option => option.value === queryModel.expectPremium);
        return label;
      }
    },
    methods: {
      validate() {
        return this.$refs.queryForm.validate(v => v);
      },
      async handleSubmit() {
        const { queryModel, type, formatCarNo, premiumLabel } = this;
        const tips = { premiumLabel };
        const isValid = await this.validate();
        if (!isValid) return;
        const payload = { ...queryModel, formatCarNo, type, tips };
        this.handleQuery(payload);
      }
    }
  };
</script>